<template>
    <div class="container">
        <p class="f18 pb20">账户信息</p>
        <el-row>
            <el-col :span="8">账户名：{{detail.commercial_name}}</el-col>
            <el-col :span="8">
                手机号：
                <el-popover
                        placement="right-start"
                        trigger="click"
                        :content="decryptStr">
                    <span class="primary cursor" slot="reference" @click="$utils.decrypt(detail.mp_encryption,(res)=>{decryptStr = res})">{{detail.mp}}</span>
                </el-popover>
            </el-col>
            <el-col :span="8">
                账号类型：
                <span v-if="detail.type==1">学校</span>
                <span v-if="detail.type==2">公司</span>
                <span v-if="detail.type==3">加盟</span>
            </el-col>
        </el-row>
        <div class="line pt10"></div>
        <p class="f18 pb20">
            合作学校
        </p>
        <!--table-->
        <el-table
                v-loading="loading"
                :data="tableData"
                border
                style="width: 100%">
            <el-table-column
                    prop="school_name"
                    label="学校名称"
                    :show-overflow-tooltip="true"
                    width="220">
            </el-table-column>
            <el-table-column
                    prop="businessCode"
                    label="业务类型"
                    width="160">
                <template slot-scope="scope">
                    <span>校内订餐</span>
                </template>
            </el-table-column>
            <el-table-column
                    prop="created_at"
                    label="开通时间"
                    :show-overflow-tooltip="true"
                    width="170">
            </el-table-column>
            <el-table-column
                    prop="commercialName"
                    label="公司名称"
                    :show-overflow-tooltip="true"
                    width="160">
                <template slot-scope="scope">
                    <span>{{detail.commercial_name}}</span>
                </template>
            </el-table-column>
            <el-table-column
                    prop="is_cooperate"
                    label="合作状态"
                    width="160">
                <template slot-scope="scope">
                    <span>{{scope.row.is_cooperate==1?'是':'否'}}</span>
                </template>
            </el-table-column>
            <el-table-column
                    prop="remit_period"
                    label="打款周期"
                    width="150">
            </el-table-column>
            <el-table-column
                    prop="complain_tel"
                    label="投诉电话"
                    width="">
                <template slot-scope="scope">
                    <el-popover
                            placement="right-start"
                            trigger="click"
                            :content="decryptStr">
                        <span class="primary cursor" slot="reference" @click="$utils.decrypt(scope.row.complain_tel_encryption,(res)=>{decryptStr = res})">{{scope.row.complain_tel}}</span>
                    </el-popover>
                </template>
            </el-table-column>
        </el-table>

        <!--pagination-->
        <el-pagination
                @size-change="handleSizeChange"
                @current-change="handleCurrentChange"
                :current-page="queryForm.pageNo"
                :page-sizes="pageSizes"
                :page-size="queryForm.pageSize"
                layout="total, sizes, prev, pager, next"
                :total="total">
        </el-pagination>
    </div>
</template>

<script>
    export default {
        computed: {

        },
        data() {
            return{
                detail: {},
                queryForm: {//查询表单数据
                    pageSize: 10,
                    pageNo: 1
                },
                tableData: [],//表格数据
                total: 0,//总数
                pageSizes: [10,20,30,40,50],//自定义分页条数
                multipleSelection: [],//table选中项
                loading: false,//表格是否显示加载效果

                decryptStr: ''
            }
        },
        created (){
            this.$store.dispatch('GetInfo').then(res => {
                this.detail = res.data;
            })
            this.initInfo();
        },
        methods: {
            initInfo() {
                this.loading = true;
                this.$api.post(this.$apiUrl.getSchoolInfo,{...this.queryForm,account_id: localStorage.getItem('userId')},(res)=>{
                    this.loading = false;
                    this.tableData = res.data.list || [];
                    this.total = res.data.total || 0;
                },(res)=>{
                    this.$message.warning(res.message);
                    this.loading = false;
                })
            },
            //切换每页显示条数操作
            handleSizeChange(val) {
                this.queryForm.pageSize = val;
                this.initInfo();
            },
            //切换页码操作
            handleCurrentChange(val) {
                this.queryForm.pageNo = val;
                this.initInfo();
            }
        }
    }
</script>
<style lang="scss"  scoped>

</style>


// WEBPACK FOOTER //
// cooperationInfo.vue?2350d5c2